import { render, staticRenderFns } from "./ObservationNewMedia.vue?vue&type=template&id=51e7a5de&scoped=true&"
import script from "./ObservationNewMedia.vue?vue&type=script&lang=js&"
export * from "./ObservationNewMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7a5de",
  null
  
)

export default component.exports